import {escapeHtml} from '../helpers';
import SvgComponent from './svg';

export default class ButtonComponent {
  static CLASSES = {
    BUTTON: 'button',
    BUTTON_ICONIC: 'button--iconic',
    BUTTON_FULL_WIDTH: 'button--full-width'
  };

  static template({
    classList,
    attributes,
    tag,
    size,
    color,
    type,
    href,
    target,
    icon,
    isIconic,
    isFullWidth,
    text = '',
    escapeText = true,
    data = {},
    download = false
  } = {}) {
    tag = tag || (href ? 'a' : 'button');

    if (escapeText) {
      text = escapeHtml(text);
    }

    let attrs = [
      `class="${[
        ButtonComponent.CLASSES.BUTTON,
        size && `${ButtonComponent.CLASSES.BUTTON}--${size}`,
        color && `${ButtonComponent.CLASSES.BUTTON}--${color}`,
        isIconic && ButtonComponent.CLASSES.BUTTON_ICONIC,
        isFullWidth && ButtonComponent.CLASSES.BUTTON_FULL_WIDTH,
        classList && classList.join(' ')
      ]
        .filter((x) => x)
        .join(' ')}"`,
      tag === 'button' && `type="${type || 'button'}"`,
      tag === 'a' && href && `href="${href}"`,
      tag === 'a' && target && `target="${target}"`,
      tag === 'a' && download && `download="${download !== true ? download : ''}"`,
      isIconic && text && `title="${text}"`,
      isIconic && text && `aria-label="${text}"`,
      data &&
        Object.keys(data)
          .map((key) => {
            return `data-${key}="${data[key]}"`;
          })
          .filter((x) => x)
          .join(' ')
    ];

    if (attributes) {
      attrs = attrs.concat(attributes);
    }

    attrs = attrs.filter((x) => x).join(' ');

    icon = icon ? SvgComponent.template({icon}) : '';
    text = !isIconic && text ? text : '';

    let innerHTML = [icon, text].filter((x) => x).join('');

    return `<${tag} ${attrs}>${innerHTML}</${tag}>`;
  }
}
